import React, { useContext, useEffect } from 'react';
import { globalHistory } from '@gatsbyjs/reach-router';
import context from '../../../../hoc/context/product/context';
import { BannerLayout } from '../../../../hoc/components/layout/banner-layout';
import {
	EventCategory,
	EventLabel,
	EventKeys,
	EventAction,
} from '../../../../../services/ga';
import Button from '../../../../hoc/components/button';
import { FlowRouteProps } from '../../../flow/flow';
import Section from '../../../../hoc/components/section/section';
import IneligibilityContent from './ineligibility-content';
import { EventType } from '../../../../../services/ga-enums-interfaces';
import { UserActionType } from '../../../../hoc/components/analytics';
import AnalyticsFactory from '../../../../../services/analytics-factory';

function Ineligibility({ flow }: FlowRouteProps) {
	const ctxt = useContext(context);
	const analytics = AnalyticsFactory.createAnalytics('ga');

	useEffect(() => {
		analytics.sendSimpleEvent(
			EventCategory.Ineligible,
			EventAction.Result,
			EventLabel.Incomplete
		);
	}, []);

	useEffect(() => {
		return globalHistory.listen(({ action }) => {
			if (action === 'POP') {
				flow.restart();
				//fixme tracking?
			}
		});
	}, [location]);

	return (
		<BannerLayout
			label={ctxt.json.pages.ineligibility.label}
			footer={true}
			mlrVersion={ctxt.json.pages.ineligibility.mlrVersion}
			title={ctxt.json.pages.ineligibility.header}>
			<Section width="max-w-4xl">
				<IneligibilityContent />
				<div className="flex justify-center whitespace-nowrap">
					<Button
						onClick={() => {
							flow.restart();
						}}
						analytics={{
							[EventKeys.EventCategory]: EventCategory.Ineligible,
							[EventKeys.EventAction]: ctxt.json.pages.ineligibility.button,
							[EventKeys.EventLabel]: EventLabel.Click,
							eventType: EventType.SimpleEvent,
							userActionType: UserActionType.click,
							eventArgs: {},
						}}>
						{ctxt.json.pages.ineligibility.button}
					</Button>
				</div>
			</Section>
		</BannerLayout>
	);
}
export default Ineligibility;
